// Canonical physical requirements checklist used on Post/Edit Job so wording
// matches exactly wherever it's selected or displayed.
export const PHYSICAL_REQUIREMENT_OPTIONS = [
  'Heavy lifting (50+ lbs)',
  'Working at heights',
  'Outdoor work in all weather',
  'Standing for long periods',
  'Confined spaces',
  'Frequent bending, kneeling, or crouching',
  'Exposure to loud noise',
];
